import { render, staticRenderFns } from "./AccidentWarranty.vue?vue&type=template&id=6fe05c22&scoped=true"
import script from "./AccidentWarranty.vue?vue&type=script&lang=js"
export * from "./AccidentWarranty.vue?vue&type=script&lang=js"
import style0 from "./AccidentWarranty.vue?vue&type=style&index=0&id=6fe05c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe05c22",
  null
  
)

export default component.exports